// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2W6d4IdyPwMlNi {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n._2W6d4IdyPwMlNi > .header-banner,\n._2W6d4IdyPwMlNi > #header {\n  flex: none;\n}\n._2W6d4IdyPwMlNi #content {\n  flex-grow: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"surface": "_2W6d4IdyPwMlNi"
};
export default ___CSS_LOADER_EXPORT___;
